import React, { useContext, useEffect } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { ThemeProvider } from '@material-ui/core';
import { Error } from './pages';
import { getRoutes } from './routes.js';
import { THDTheme } from './theme';
import './styles/app.scss';
import { redirectToSignInEncoded } from './utils/general';
import { isLoggedIn } from './utils/user';
const ProtectedRoute = ({ children, customerType, customerRole, }) => {
    // client-side only check -- do not use for conditional rendering
    const isUserLoggedIn = isLoggedIn();
    const isB2B = (customerType === null || customerType === void 0 ? void 0 : customerType.toUpperCase()) === 'B2B';
    const isAdmin = (customerRole === null || customerRole === void 0 ? void 0 : customerRole.toUpperCase()) === 'ADMIN';
    const shouldRedirect = !isB2B || !isAdmin;
    useEffect(() => {
        // due to the fact shouldRedirect will also be true for non-logged in users, perform this check first
        if (!isUserLoggedIn) {
            redirectToSignInEncoded();
            return;
        }
        if (shouldRedirect) {
            window.location.replace('/myaccount/dashboard');
        }
    }, [shouldRedirect]);
    if (shouldRedirect) {
        return null;
    }
    return children;
};
export const App = ({ customerType, customerRole, userId, svocId, }) => {
    const { instance } = useContext(AppContext);
    const { currentRouteName, currentRouteComponent } = instance.router;
    const routes = getRoutes(currentRouteName, currentRouteComponent);
    useEffect(() => {
        document.title = 'The Home Depot';
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ThemeProvider, { theme: THDTheme },
            React.createElement(ScrollToTop, null),
            React.createElement(Routes, null,
                React.createElement(Route, { path: routes.registration.path, element: React.createElement(ProtectedRoute, { customerType: customerType, customerRole: customerRole },
                        React.createElement(routes.registration.component, { userId: userId, svocId: svocId })) }),
                React.createElement(Route, { path: routes.pricingBenefits.path, element: React.createElement(ProtectedRoute, { customerType: customerType, customerRole: customerRole },
                        React.createElement(routes.pricingBenefits.component, null)) }),
                React.createElement(Route, { path: "/error", element: React.createElement(Error, null) }),
                React.createElement(Route, { element: React.createElement(Error, null) })))));
};
